import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { AuthService } from '../../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {
  constructor(public authService: AuthService) {}

  canActivate(): Observable<boolean> {
    return new Observable((observer: any) => {
      if (!this.authService.isAuthenticated()) {
        this.authService.logout();
        return observer.next(false);
      }
      return observer.next(true);
    });
  }
}
